import { useStyles } from "./AdminStyles";
import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";


const MenuOptions = ({ item, active, onClick }) => {
  const classes = useStyles();
  const disabled = item.status !== "Active";

  return (
    <ListItem
      button
      key={item.id}
      onClick={onClick}
      disabled={disabled}
      selected={active}
      style={{
        backgroundColor: active ? '#0083C2' : '#ffffff',
        color: active ? '#ffffff' : 'inherit',
        border: active ? '1px solid #0083C2' : '',
      }}
    >
      <ListItemIcon
        style={{
          color: active ? '#ffffff' : 'inherit',
          minWidth: '40px',
        }}
      >
        {item.icon}
      </ListItemIcon>
      <ListItemText
        primary={item.title}
        style={{
          color: active ? '#ffffff' : 'inherit',
        }}
        primaryTypographyProps={{
          style: {
            color: active ? '#ffffff' : 'inherit',
            fontWeight: active ? 600 : 'normal',
          }
        }}
      />
    </ListItem>
  );
};

export default MenuOptions;
